var _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.099,
    height: 20.099,
    viewBox: "0 0 20.099 20.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 10.05,
    cy: 10.05,
    r: 10.05,
    transform: "translate(0 0)",
    fill: "#32ba7c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M188.8,160.56l5.167,5.167a10.043,10.043,0,0,0,7.45-9.7v-.285L197.36,152Z",
    transform: "translate(-181.318 -145.977)",
    fill: "#0aa06e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(3.376 4.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M92.127,203.991a1.187,1.187,0,0,1,0,1.648l-.919.919a1.187,1.187,0,0,1-1.649,0L85.533,202.5a1.187,1.187,0,0,1,0-1.649l.919-.919a1.187,1.187,0,0,1,1.649,0Z",
    transform: "translate(-85.2 -196.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M171.707,125.533a1.187,1.187,0,0,1,1.649,0l.919.919a1.187,1.187,0,0,1,0,1.649l-6.974,6.943a1.187,1.187,0,0,1-1.649,0l-.919-.919a1.187,1.187,0,0,1,0-1.649Z",
    transform: "translate(-161.261 -125.2)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.8db035cdc8bdf978e8c38a677345e88b.svg";
export { ForwardRef as ReactComponent };